<template>
  <DxPopup @hidden="onHidden" :visible="showEpms101p" :show-close-button="true" :show-title="true" :title="'Quotation Request Sheet'" height="900px" width="1024px" container=".v-application">
    <template #content>
      <DxScrollView
        width="100%"
        height="100%"
      >
        <div class="px-2 d-flex justify-end">
          <iButtonList :useBtnList="['btnPrint']" @btnClick="btnPrint($event)" />
        </div>
        <v-container fluid align-start ma-0 pa-2 class="epms101p-main h-full d-flex justify-center">
          <table width="900" border="0" cellpadding="0" cellspacing="0" align="center">
            <tr height="40" align="center">
              <td style="font-size:20pt; font-weight:bold;">HD HYUNDAI VIETNAM SHIPBUILDING CO., LTD.</td>
            </tr>
            <tr height="25" align="center" valign="bottom">
              <td style="font-size:14pt; border-color:#000000; border-bottom-width:3px; border-bottom-style:solid;">
                01 MỸ GIANG, NINH PHƯỚC, NINH HÒA, KHÁNH HÒA, VIỆT NAM
              </td>
            </tr>
            <tr height="10">
              <td></td>
            </tr>
            <!-- Title -->
            <tr>
              <td>
                <table width="900" border="0" cellpadding="0" cellspacing="0" align="center">
                  <!-- 1st Line -->
                  <tr height="35">
                    <td  class="px-1" width="110" style="font-size:13pt; border-color:#000000; border-top-width:1px; border-bottom-width:1px; border-left-width:1px; border-top-style:solid; border-bottom-style:solid; border-left-style:solid;" align="center">Báo giá số</td>
                    <td  class="px-1" width="270" style="font-size:13pt; border-color:#000000; border-top-width:1px; border-bottom-width:1px; border-left-width:1px; border-top-style:solid; border-bottom-style:solid; border-left-style:solid; font-weight:bold;">{{ headerData.quotNo }}</td>
                    <td  class="px-1" width="130" style="font-size:13pt; border-color:#000000; border-top-width:1px; border-bottom-width:1px; border-left-width:1px; border-top-style:solid; border-bottom-style:solid; border-left-style:solid;" align="center">Người Gửi</td>
                    <td  class="px-1" style="font-size:13pt; border-color:#000000; border-top-width:1px; border-bottom-width:1px; border-left-width:1px; border-right-width:1px; border-top-style:solid; border-bottom-style:solid; border-left-style:solid; border-right-style:solid;">
                      {{ `${headerData.buyerName}(${headerData.buyerEmail})` }}
                    </td>
                  </tr>
                  <!-- 2nd Line -->
                  <tr height="35">
                    <td  class="px-1" width="110" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;" align="center">Đến</td>
                    <td  class="px-1" width="270" style="font-size:13pt; border-color:#000000;  border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;">{{ headerData.supplierName }}</td>
                    <td  class="px-1" width="130" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;" align="center">Số Điện Thoại</td>
                    <td  class="px-1" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-right-width:1px; border-bottom-style:solid; border-left-style:solid; border-right-style:solid;">(058) 3622 101</td>
                  </tr>
                  <!-- 3rd Line-->
                  <tr height="35">
                    <td  class="px-1" width="110" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;" align="center">Đồng gửi</td>
                    <td  class="px-1" width="270" style="font-size:13pt; border-color:#000000;  border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;">Sales person in charge</td>
                    <td  class="px-1" width="130" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;" align="center">Số FAX</td>
                    <td  class="px-1" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-right-width:1px; border-bottom-style:solid; border-left-style:solid; border-right-style:solid;">(058) 3622 089</td>
                  </tr>
                  <!-- 4th Line-->
                  <tr height="35">
                    <td  class="px-1" width="110" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-left-width:1px; border-bottom-style:solid; border-left-style:solid;" align="center">Tiêu đề</td>
                    <td  class="px-1" colspan="3" style="font-size:13pt; border-color:#000000;  border-bottom-width:1px; border-left-width:1px; border-right-width:1px; border-bottom-style:solid; border-left-style:solid; border-right-style:solid;">{{ headerData.quotTitle }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr height="20"><td></td></tr>
            <tr>
              <td style="font-size:13pt;">
                <ol type="I">
                  <li>Cám ơn sự hợp tác và hi vọng mối quan hệ công việc của chúng ta ngày càng tốt đẹp hơn.<br><br></li>
                  <li>Chúng tôi yêu cầu bảng báo giá với tựa đề trên, vui lòng gửi bảng báo giá đúng thời hạn và hợp đồng được chọn theo những hướng dẫn sau đây :<br><br></li>
                  <ol type="1">
                    <li>Hiện tại công ty chúng tôi có chính sách giá đối với những nhà cung cấp có giá đấu thầu cuối cùng.<br><br></li>
                    <li>Chúng tôi sẽ loại trừ những nhà cung cấp có mức giá và những nhà cung cấp có giá đấu thầu cuối cùng mà vượt quá 20% so với báo giá thấp nhất, nhằm ngăn chặn những báo giá không đủ tin cậy.<br><br></li>
                    <li>Với vật tư có số tiền nhỏ, chúng tôi có thể chọn khách hàng dựa vào báo giá đầu tiên.<br><br></li>
                  </ol>
                  <center>*** Như sau ***<br><br></center>
                  <ol type="a">
                    <li>Phạm vi cung cấp và đặc điểm<br>
                      <table width="800" border="0" cellpadding="0" cellspacing="0">
                        <tr height="10"><td colspan="5" style="border-color:#000000; border-bottom-width:1px; border-bottom-style:solid;">&nbsp;</td></tr>
                        <tr height="20">
                          <td width="150" style="font-size:13pt;">POR NO.</td>
                          <td width="200" style="font-size:13pt;">MATERIAL CODE</td>
                          <td width="100" style="font-size:13pt;">UNIT</td>
                          <td width="180" style="font-size:13pt;" align="right">QUANTITY/WEIGHT</td>
                          <td style="font-size:13pt;" align="right">DELIVERY DATE</td>
                        </tr>
                        <tr height="20">
                          <td colspan="5" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-bottom-style:solid;">ITEM & SPECIFICATION</td>
                        </tr>
                        <template v-for="(data, idx) in dataList">
                          <tr height="20" :key="'row1__' + idx">
                            <td width="150" style="font-size:13pt;">{{ data.porNo }}</td>
                            <td width="200" style="font-size:13pt;">{{ data.matlCd }}</td>
                            <td width="100" style="font-size:13pt;">{{ data.matlUnit }}</td>
                            <td width="180" style="font-size:13pt;" align="right">{{ data.qty }}</td>
                            <td style="font-size:13pt;" align="right">{{ data.whReqDte }}</td>
                          </tr>
                          <tr height="20" :key="'row2__' + idx">
                            <td colspan="5" style="font-size:13pt; border-color:#000000; border-bottom-width:1px; border-bottom-style:solid;">{{ data.matlSpec }}</td>
                          </tr>
                        </template>
                      </table><br>
                    </li>
                    <li>Thời hạn thanh toán : {{ headerData.payCondDesc }}<br><br></li>
                    <li>Thời hạn giao hàng : {{ headerData.transCondDesc }}<br><br></li>
                    <li>Thời hạn kiểm tra : HVS Q.C<br><br></li>
                    <li>Thời hạn bảo hành : Material Trade basic contract<br><br></li>
                    <li>Chi phí kiểm tra : Non Inspection<br><br></li>
                    <li>Đóng sổ báo giá : {{ headerData.closeTime }}<br><br></li>
                    <li>V.v... : {{ headerData.filePath ? 'Additional File' : '' }}<br><br></li>
                    <li>Người Phụ trách : <br><br></li>
                  </ol>
                </ol>
              </td>
            </tr>
            <template v-if="dataList.length < 10">
              <template v-for="idx in (10 - dataList.length)">
                <tr height="40" :key="'blank_' + idx"><td>&nbsp;</td></tr>
              </template>
            </template>
            <tr height="40">
              <td style="font-size:20pt; font-weight:bold;" align="center">TRƯỞNG PHÒNG VẬT VƯ</td>
            </tr>
          </table>
        </v-container>
      </DxScrollView>
    </template>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { getPrintRequestSheetA } from '@/api/view/hip/common/common.js'
import iButtonList from '@/components/common/iButtonList'

export default {
  name: 'epms101p',
  props: {
    showEpms101p: {
      type: Boolean,
      default() {
        return false
      }
    },
    param: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    DxPopup,
    DxScrollView,
    iButtonList
  },
  data() {
    return {
      headerData: {},
      dataList: [],
      initBodyHtml: null
    }
  },
  methods: {
    btnPrint(e) {
      if(e.id === 'btnPrint') {
        const printElement =document.getElementsByClassName('epms101p-main')[0]
        const printPop = window.open(' ', 'print', 'height=800, width=1024')
        printPop.document.write('<html><head><center><tile>Quotation Request Sheet</tile></center></head><body>')
        printPop.document.write(printElement.innerHTML)
        printPop.document.write('</body></html>')
        printPop.document.close()
        printPop.print()
        printPop.close()
      }
    },
    getDataList() {
      this.dataList = []

      const param = {
        quotNo: this.param.quotNo,
        makerCd: this.param.makerCd
      }

      // console.log('param', param)
      // console.log('this.param', this.param)

      getPrintRequestSheetA(param).then(res => {
        // console.log('res', res)

        this.dataList = res.list

        if(this.dataList.length > 0) {
          this.headerData = this.dataList[0]
        }
      })
    },
    onHidden(e) {
      this.$emit('update:showEpms101p', false)
    }
  },
  mounted() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>

</style>